import { Component, OnInit } from "@angular/core";
import { CustomerService } from "../../../services/login.service";
import { ForgotPasswordService } from "../../../services/forgotPassword/forgot-password.service";
import { Router } from "@angular/router";
import { loginModel } from "../../../interfaces/login";
import { forgotPasswordModel } from "../../../interfaces/forgotPassword.model";
import { UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import { NeedAuthGuardService } from "../../../services/Auth/need-auth-guard.service";
import { LoginFade,LogoFade } from 'src/app/animations/template.animations';
import { SnackbarService } from "src/app/services/home/snackbar.service";
import { FireBaseService } from "src/app/services/fireBase-service/fire-base.service";
import { NgxPermissionsService } from "ngx-permissions";
import { UserInfoModel } from "src/app/interfaces/UserInfo.model";
import { Keywords } from "src/app/enums/kewords.enum";
import { Store } from "@ngxs/store";
import { GetLanguages } from "src/app/store/language/language.action";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  animations: [LoginFade,LogoFade]
})

export class LoginComponent implements OnInit {
  constructor(
    private customerService: CustomerService,
    private router: Router,
    private forgotPasswordService : ForgotPasswordService,
    private needAuthGuardService: NeedAuthGuardService,
    private snackbarService: SnackbarService,
    private fb: UntypedFormBuilder,
    private fireBaseService : FireBaseService,
    private permissionsService: NgxPermissionsService,
    private store: Store
    ) {}

  //Declerations
  loginForm: UntypedFormGroup;
  ForgotPasswordForm: UntypedFormGroup;
  username: string;
  password: string;
  ShowSpinner: boolean = false;
  isLoggedError: boolean = false;
  errorMsg: string;
  HidePassword :boolean = true;
  ForgotPassword : boolean = false;
  ForgotPasswordPlaceHolder : string = 'Send New Password by';

  ngOnInit() {
    this.permissionsService.flushPermissions();
    this.createForm();
  }

  close() {
    this.isLoggedError = false;
  }

  createForm() {
    let EtlooCredentials = sessionStorage.getItem('EtlooCredentials');
    if (EtlooCredentials) EtlooCredentials = JSON.parse(EtlooCredentials);
    this.loginForm = this.fb.group({
      email: [EtlooCredentials ? EtlooCredentials['Name'] : '', Validators.required],
      password: [EtlooCredentials ? EtlooCredentials['Password'] : '', Validators.required],
      rememberMe: [EtlooCredentials ? true : false, Validators.required],
      
    });
  }

  createForgotPasswordForm() {
    this.ForgotPasswordForm = this.fb.group({
      email: ['', Validators.required],
    });
  }

  prepareInfo() : loginModel {
    const controls = this.loginForm.controls;
    const _Info = new loginModel();
    _Info.email = controls["email"].value;
    _Info.password = controls["password"].value;
    _Info.fireBaseToken=this.fireBaseService.fireBaseToken$
    return _Info;
  }


  prepareForGotPasswordInfo() : forgotPasswordModel {
    const controls = this.ForgotPasswordForm.controls;
    const _Info = new forgotPasswordModel();
    _Info.email = controls["email"].value;
    return _Info;
  }

  OnSubmit() {
    const controls = this.loginForm.controls;
    /** check form */
    if (this.loginForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.tryLogin();
    this.ShowSpinner = true;
    this.DisableInputs();
  }

  OnSubmitForgotPassword(state : string) {
    // state = byMail || byPhone
    const controls = this.ForgotPasswordForm.controls;
    /** check form */
    if (this.ForgotPasswordForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    const ForgotModel : forgotPasswordModel = this.prepareForGotPasswordInfo();
    ForgotModel.byEmail = state == 'byMail' ? true : false;
    this.GetForgetPassword(ForgotModel)
  }

  tryLogin() {
    let Obj = this.prepareInfo();

  this.needAuthGuardService.Login(Obj).subscribe(
    {
      next :(data) => {
        if (data.body.succeeded ) {
          let userInfo : UserInfoModel = data.body.data; 
          let state = this.customerService.setToken(userInfo.token);
        
          sessionStorage.setItem(Keywords.USER_INFO, JSON.stringify(userInfo));
          
          this.ShowSpinner = false;
          this.EnableInputs();
          let a=JSON.parse(atob(userInfo.token.split('.')[1])).permissions
          a = a.replace(/'/g, '"');
           a = JSON.parse(a);
         this.customerService.setUserPermissions(a)
          if(sessionStorage.getItem(Keywords.USER_PERMISSIONS)){
            this.permissionsService.loadPermissions(JSON.parse(sessionStorage.getItem(Keywords.USER_PERMISSIONS)));
          }
          this.store.dispatch(new GetLanguages());
          this.router.navigate(["home"]);
        }
        else {
          this.errorMsg = (Array.isArray(data.body?.messages) && data.body?.messages.length>0) ? data.body.messages[0] : 'Error';
        }
          this.isLoggedError = true;
          this.ShowSpinner = false;
          this.EnableInputs();
      } ,
      error : (error)=>{
        console.log(error)
        this.isLoggedError = true;
        this.errorMsg = (Array.isArray(error.error?.messages) && error.error?.messages.length>0) ? error.error.messages[0] : 'Error';
        this.ShowSpinner = false;
        this.EnableInputs();
      }
    }
  );
}

  DisableInputs() {
    const controls = this.loginForm.controls;
    controls["email"].disable();
    controls["password"].disable();
  }

  EnableInputs() {
    const controls = this.loginForm.controls;
    controls["email"].enable();
    controls["password"].enable();
  }

  RememberMe(): void {
    let FormValues = this.prepareInfo();
    if(!FormValues.email || !FormValues.password)
        return
    else
      sessionStorage.setItem('EtlooCredentials', JSON.stringify({'Name': FormValues.email, 'Password': FormValues.password}));
  }

  ForgetMe(): void {
    sessionStorage.removeItem('EtlooCredentials');
  }

  rememberMeChanged(e): void {
    if (e.checked)
      this.RememberMe();
    else
      this.ForgetMe();
  }

  IForgotPassword() : void {
    this.ForgotPassword = true;
    this.createForgotPasswordForm();
  }

  //
  GetForgetPassword(ForgotModel : forgotPasswordModel) : void {
    this.ShowSpinner = true;
    let fakePagenation = {};
    fakePagenation['email'] = ForgotModel.email;
    fakePagenation['byEmail'] = ForgotModel.byEmail;
    this.ForgotPasswordPlaceHolder = 'Sending New Password';
    let string = ForgotModel.byEmail == true ? 'Email Account' : 'Phone Number';
    this.forgotPasswordService.Get('ForgetPassword', fakePagenation).subscribe(
      res => {
        this.ShowSpinner = false;
        if(res.body.succeeded){
          this.snackbarService.openSnackBar('Password has been sent to your ' + string, '', 'success');
          this.BacktoLogin();
        }
        else{
          this.snackbarService.openSnackBar(res.body.msg, '', 'Info');
          this.IForgotPassword();
        }
      }
    );
  }

  BacktoLogin(){
    this.ForgotPassword = false;
    this.createForm();
  }

}
